// Per-job stopwatch helpers backed by localStorage (survives reloads).
const key = (id) => `jdm_job_timer_${id}`;

export const fmtHMS = (ms) => {
  const t = Math.floor((ms || 0) / 1000);
  const h = String(Math.floor(t / 3600)).padStart(2, "0");
  const m = String(Math.floor((t % 3600) / 60)).padStart(2, "0");
  const s = String(t % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export const parseHMS = (str) => {
  if (!str) return 0;
  const parts = String(str).split(":").map((x) => parseInt(x, 10) || 0);
  let sec = 0;
  if (parts.length === 3) sec = parts[0] * 3600 + parts[1] * 60 + parts[2];
  else if (parts.length === 2) sec = parts[0] * 60 + parts[1];
  else sec = parts[0];
  return sec * 1000;
};

export const loadTimer = (id, seedMs = 0) => {
  try {
    const saved = JSON.parse(localStorage.getItem(key(id)));
    if (saved) return saved;
  } catch (e) {}
  return { running: false, accumulated: seedMs || 0, startedAt: null };
};

export const saveTimer = (id, state) => {
  try { localStorage.setItem(key(id), JSON.stringify(state)); } catch (e) {}
};

export const clearTimer = (id) => {
  try { localStorage.removeItem(key(id)); } catch (e) {}
};

export const setTimerMs = (id, ms) => saveTimer(id, { running: false, accumulated: Math.max(0, ms), startedAt: null });

export const elapsedOf = (s) => s.accumulated + (s.running && s.startedAt ? Date.now() - s.startedAt : 0);
